module.exports = new __parcel__URL__("creme-company.ca71e074.png").toString();